// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d6Hp4","space":"styles_space__UGu2v","content":"styles_content__-qCp7"};